import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/index.scss';
import App from './App';
import SearchWidget from './components/SearchWidget';
import reportWebVitals from './reportWebVitals';

// Render the main app if the container exists
const rootElement = document.getElementById('ax-tyres-catalog-root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Render the search widget if the container exists
const widgetElement = document.getElementById('ax-tyres-search-widget-root');
if (widgetElement) {
  const widgetRoot = ReactDOM.createRoot(widgetElement);
  widgetRoot.render(
    <React.StrictMode>
      <SearchWidget />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
